import { Component, OnDestroy, ViewChild, ElementRef, Input, SimpleChanges, OnChanges, NgZone, ChangeDetectorRef } from '@angular/core';
import Calendar from '@toast-ui/calendar';
import { lightThemeV2, darkThemeV2 } from './calendar-themes';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  standalone: false,
})
export class CalendarComponent implements OnChanges, OnDestroy {
  constructor(
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) { }

  @Input() year!: number;
  @Input() month!: number;
  tituloMes = '';

  @ViewChild('calendar', { static: true }) calendarRef!: ElementRef<HTMLDivElement>;
  private calendar: any;
  private observer!: MutationObserver;

  anios: any[] = [];
  anioSeleccionado: number = 2024 // año por defecto

  showDialog = false;
  eventoSeleccionado: any = null;
  data: any[] = [];
  eventDetails: Record<string, any[]> = {};


  private actualizarTituloMes() {
    const nombresMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    if (this.year && this.month && this.month >= 1 && this.month <= 12) {
      this.ngZone.run(() => {
        this.tituloMes = `${nombresMeses[this.month - 1]} ${this.year}`;
        this.cdr.detectChanges();
      });
    }
  }

  ngOnInit() {
    this.anios = Array.from({ length: 5 }, (_, i) => {
      const anio = 2021 + i;
      return { label: anio.toString(), value: anio };
    });

    // si los valores no son pasados desde el padre
    if (!this.year) this.year = this.anioSeleccionado;
    if (!this.month) this.month = new Date().getMonth() + 1; // mes del sistema

    this.createCalendar();
    this.actualizarTituloMes();
  }

  onAnioChange(event: any) {
    const nuevoAnio = event.value;
    this.anioSeleccionado = nuevoAnio;
    this.year = nuevoAnio;

    this.setCalendarDate();
    this.loadSchedules();
    this.actualizarTituloMes();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.calendar) return; // si el calendario aún no existe, no hacemos nada
    if (changes['year'] || changes['month']) {
      this.setCalendarDate();
      this.loadSchedules();
      this.actualizarTituloMes();
    }
  }

  // private createCalendar() {
  //   const isDarkMode = document.body.classList.contains('app-dark');

  //   if (this.calendar) this.calendar.destroy();

  //   this.calendar = new Calendar(this.calendarRef.nativeElement, {
  //     defaultView: 'month',
  //     usageStatistics: false,
  //     isReadOnly: true,
  //     month: {
  //       startDayOfWeek: 1,
  //       dayNames: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"]
  //     },
  //     // template: {
  //     //   allday: (event) => {
  //     //     const icon = event.calendarId === '1'
  //     //       ? '<span style="margin-right:4px;">🟢</span>'
  //     //       : '<span style="margin-right:4px;">🔴</span>';

  //     //     // Usamos directamente las propiedades que ya vienen en el objeto 'event'
  //     //     return `
  //     //       <div style="
  //     //         display:flex;
  //     //         align-items:center;
  //     //         padding:2px;
  //     //         border-radius:4px;
  //     //         background-color:${event.backgroundColor};
  //     //         color:${event.color};
  //     //         font-size:12px;
  //     //         font-weight:600;
  //     //         box-sizing:border-box;">
  //     //           ${icon} ${event.title}
  //     //       </div>
  //     //     `;
  //     //   }
  //     // },
  //     theme: isDarkMode ? darkThemeV2 : lightThemeV2,
  //   });

  //   // Observador para cambios de modo oscuro
  //   this.observer = new MutationObserver(() => {
  //     const classList = document.body.classList;
  //     const isDark = [...classList].some(c => c.includes('dark'));
  //     this.toggleDarkMode(isDark);
  //   });
  //   this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  //   // Click en evento para abrir diálogo
  //   this.calendar.on('clickEvent', (info: any) => {
  //     const eventId = info.event.id;
  //     // Guardamos solo una copia plana para evitar modificar objetos read-only
  //     this.eventoSeleccionado = {
  //       id: eventId,
  //       title: info.event.title,
  //       start: info.event.start,
  //       end: info.event.end
  //     };
  //     this.data = this.eventDetails[eventId] || [];
  //     this.showDialog = true;
  //   });

  //   this.setCalendarDate();
  //   this.loadSchedules();
  // }

  // calendar.component.ts
  private createCalendar() {
    const isDarkMode = document.body.classList.contains('app-dark');

    // Si ya existe uno lo destruye para no duplicar
    if (this.calendar) this.calendar.destroy();

    // Config principales para el calendario
    this.calendar = new Calendar(this.calendarRef.nativeElement, {
      defaultView: 'month',
      usageStatistics: false,
      isReadOnly: true,
      month: {
        startDayOfWeek: 1,
        dayNames: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"]
      },
      template: {
        allday: (event) => {
          const icon = event.calendarId === '1'
            ? '<span style="margin-right:4px;">🟢</span>'
            : '<span style="margin-right:4px;">🔴</span>';

          return `
            <div style="
              display:flex;
              align-items:center;
              padding:2px;
              border-radius:4px;
              background-color:${event.backgroundColor};
              color:${event.color};
              font-size:12px;
              font-weight:600;
              box-sizing:border-box;">
              ${icon} ${event.title}
            </div>
          `;
        }
      },
      theme: isDarkMode ? darkThemeV2 : lightThemeV2,
    });

    // Observador para cambios de modo oscuro
    this.observer = new MutationObserver(() => {
      const classList = document.body.classList;
      const isDark = [...classList].some(c => c.includes('dark'));
      this.toggleDarkMode(isDark);
    });
    this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Click en evento para abrir diálogo
    this.calendar.on('clickEvent', (info: any) => {
      const eventId = info.event.id;
      this.eventoSeleccionado = {
        id: eventId,
        title: info.event.title,
        start: info.event.start,
        end: info.event.end
      };
      this.data = this.eventDetails[eventId] || [];
      this.showDialog = true;
    });

    // Llama a las funciones iniciales para cargar los datos la primera vez
    this.setCalendarDate();
    this.loadSchedules();
  }

  /**
   * @description Creamos nueva fecha usando valores recibidos como input
   * @param this.year -> valor de input
   * @param this.month - 1 porque Date empieza en 0 (ene = 0, feb = 1, ...)
   * 1 -> primer dia del mes
   */
  private setCalendarDate() {
    if (this.year && this.month) {
      this.calendar.setDate(new Date(this.year, this.month - 1, 1));
    }
  }

  /**
   * @description Definimos los eventos
   * @returns eventos según mes y año
   */
  private loadSchedules(): void {
    if (!this.year || !this.month || !this.calendar) return;

    // Limpiar eventos previos
    if (this.calendar.clear) this.calendar.clear();
    if (this.calendar.deleteAllSchedules) this.calendar.deleteAllSchedules();
    this.eventDetails = {};

    // Función para crear un objeto de evento completamente nuevo
    const createEvent = (d: any, i: number, type: 'abierto' | 'vencido') => {
      const eventId = `${type}-${i}`;
      this.eventDetails[eventId] = [d]; // guardamos para el diálogo
      return {
        id: eventId,
        calendarId: type === 'abierto' ? '1' : '2',
        title: type === 'abierto' ? `Abierto (1)` : `Vencido (1)`,
        start: d.fecha,
        end: d.fecha,
        isAllday: true,
        category: 'allday',
        // color: '#ffffff', // texto
        // borderColor: type === 'abierto' ? '#1e853f' : '#782020',
        // backgroundColor: type === 'abierto' ? '#40a83b' : '#c94d4d',
        origen: d.origen,
        destino: d.destino,
        conductor: d.conductor,
        autoriza: d.autoriza
      };
    };

    // Crear eventos "abiertos"
    this.abiertos
      .filter(d => {
        const fecha = new Date(d.fecha);
        return fecha.getFullYear() === this.year && (fecha.getMonth() + 1) === this.month;
      })
      .forEach((d, i) => {
        const newEvent = createEvent(d, i, 'abierto');
        this.calendar.createEvents([newEvent]);
      });

    // Crear eventos "vencidos"
    this.vencidos
      .filter(d => {
        const fecha = new Date(d.fecha);
        return fecha.getFullYear() === this.year && (fecha.getMonth() + 1) === this.month;
      })
      .forEach((d, i) => {
        const newEvent = createEvent(d, i, 'vencido');
        this.calendar.createEvents([newEvent]);
      });
  }

  toggleDarkMode(isDark: boolean) {
    if (!this.calendar) return;
    this.calendar.setTheme(isDark ? darkThemeV2 : lightThemeV2);
    this.calendar.render(); // fuerza re-render (ayuda en algunos casos)
  }

  ngOnDestroy(): void {
    this.calendar?.destroy?.();
    if (this.observer) this.observer.disconnect();
  }

  // PARA TABLA
  abiertos = [
    { id: 69975, fecha: '2024-08-04', origen: 'Base', destino: 'Canepa', conductor: 'Aravena Dagoberto Martin', autoriza: 'Jorge' },
    { id: 69989, fecha: '2024-08-11', origen: 'Base nqn', destino: 'Wp 024', conductor: 'Cerda Jorge Segundo', autoriza: 'Julio' },
    { id: 69991, fecha: '2024-08-12', origen: 'Pozo LLL-1865(h)', destino: 'Base Z1', conductor: '', autoriza: 'Gustavo' },
    { id: 69992, fecha: '2024-04-18', origen: 'Wo008', destino: 'Base Z1', conductor: '', autoriza: 'Jorge' }
  ];

  vencidos = [
    { id: 69791, fecha: '2024-08-27', origen: 'LLL 1864', destino: 'Base Z1', conductor: 'Castillo Denis Alejandro', autoriza: 'Daniel' },
    { id: 69870, fecha: '2024-08-27', origen: 'Base cr', destino: 'DLC ZORRO', conductor: 'Fernandez Hector Damian', autoriza: 'Mariano Alberto' },
    { id: 67716, fecha: '2024-07-08', origen: 'Base nqn', destino: 'AGLA-016', conductor: 'Timm Pablo E.', autoriza: 'Carlos Martin' },
    { id: 68998, fecha: '2024-07-31', origen: 'Wp-008', destino: 'Base Neuquén', conductor: 'Aizpeolea Marcos Lucas', autoriza: 'Guillermo' },
    { id: 57021, fecha: '2024-01-21', origen: 'Cl1864', destino: 'Base lh', conductor: 'Ramos Alfredo M.', autoriza: 'Fernando Javier' }
  ];

}
